import type { S2PElevateSlide } from "@/data/s2pElevateAI";

export const RECORD_SKILL_SLIDE: S2PElevateSlide = {
  id: "record-a-skill",
  session: 3,
  kind: "record-skill",
  tone: "paper",
  title: "Show the workflow. Save the Skill.",
  eyebrow: "Session 3 · Teach by demonstration",
  durationMinutes: 3,
  lead: "Watch a short workflow recording and review the proposed Skill. Use it to compare tool fit; test with a new input in Session 4.",
  sourceIds: ["elevate.record-a-skill"],
};

// Product paths and availability checked against these vendor guides on 2026-09-25.
export const RECORD_SKILL_TOOLS = [
  {
    name: "Claude Cowork",
    path: "Settings → Skills → Add → Record your screen",
    detail: "Also available under Customize → Skills. Mac desktop; Pro, Max, or Team.",
    href: "https://support.claude.com/en/articles/12512198-how-to-create-custom-skills",
  },
  {
    name: "ChatGPT Work",
    path: "Work → Plugins → + → Record a skill",
    detail: "Mac desktop with Computer Use enabled. Review the prompt, then approve recording. Also available in Codex.",
    href: "https://learn.chatgpt.com/docs/extend/record-and-replay",
  },
];

export const RECORD_SKILL_EXAMPLES = [
  {
    title: "Weekly status report",
    demonstrate: "Filter a sample tracker by week, select overdue items, and fill your status template.",
    replay: "How might we draft next week’s status report within human review boundaries, based on my weekly-report Skill and the new tracker? Flag missing owners and leave a draft for review.",
  },
  {
    title: "Meeting follow-up",
    demonstrate: "Turn sample notes into an action table with owners and dates, then prepare an email draft.",
    replay: "How might we prepare a meeting follow-up within draft-only boundaries, based on my meeting-follow-up Skill and these new notes? Mark uncertain dates and stop before sending.",
  },
];
